<template>
  <div>
    <div
      v-for="error in storeErrors"
      :key="error.id"
    >
      <div class="alert alert-danger">
        <button
          type="button"
          class="close"
          @click="closeError(error.id)"
        >
          ×
        </button>

        <span>
          <b
            v-if="error.title"
            class="text-2xl mb-4 block"
          >
            {{ error.title }}
          </b>
          <div v-if="error.messages.length">
            <span
              v-for="message in error.messages"
              :key="message"
            >
              <p>{{ message }}</p>
            </span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LoggerBus } from "@app/utils/logger-bus";
const loggerFormat = "[components::error::listener]";

export default {
  name: "ErrorListener",
  data() {
    return {
      defaultMessage: "Whoops! There was an error."
    };
  },
  computed: {
    ...mapGetters("errorStore", ["getErrors", "error"]),
    storeErrors() {
      this.hasError();
      const errors = this.getErrors;
      return errors;
    }
  },
  methods: {
    ...mapActions("errorStore", ["removeErrorById", "clearErrors"]),
    closeError(id) {
      this.removeErrorById(id);
    },
    hasError() {
      if (!this.error) {
        return;
      }
      const error = this.error;
      LoggerBus.$log.debug(loggerFormat, error);

      let message = `${error.statusText}: ${error.message}`;

      if (error.status !== 401 && error.status !== 403) {
        // message = `${error.statusText}`;
        message = `${this.defaultMessage}`;
      }

      const isProduction = process.env.NODE_ENV === "production";
      message = isProduction
        ? message
        : `${error.status} : ${error.exception} : ${error.statusText} : ${error.message}`;

      return this.notify(message);
    },
    notify(message) {
      this.$notify({
        message,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger"
      });
      this.clearErrors();
    }
  }
};
</script>
